import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import ResultCard from './ResultCard';
import './SingleValidator.css';

const API = process.env.REACT_APP_API_URL || '';

export default function SingleValidator() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleValidate = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return toast.error('Please enter an email address');

    setLoading(true);
    setResult(null);
    try {
      const { data } = await axios.post(`${API}/api/validate`, { email: trimmed });
      setResult(data);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Validation failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => { setEmail(''); setResult(null); };

  return (
    <div className="single-validator">
      <div className="sv-card">
        <div className="sv-card-header">
          <h2 className="sv-title">Validate a Single Email</h2>
          <p className="sv-desc">
            Run a full 6-point technical check: syntax, DNS/MX, SPF, DMARC, disposable detection, and SMTP probe.
          </p>
        </div>
        <form className="sv-form" onSubmit={handleValidate}>
          <div className="sv-input-row">
            <div className="sv-input-wrap">
              <span className="sv-input-icon">✉</span>
              <input
                type="text"
                className="sv-input"
                placeholder="Enter email address, e.g. user@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="off"
                spellCheck={false}
                disabled={loading}
              />
              {email && !loading && (
                <button type="button" className="sv-clear-btn" onClick={handleClear} title="Clear">✕</button>
              )}
            </div>
            <button type="submit" className="sv-validate-btn" disabled={loading || !email.trim()}>
              {loading ? <><span className="spinner" /> Checking…</> : 'Validate'}
            </button>
          </div>
        </form>

        <div className="sv-checks-preview">
          {['Syntax', 'DNS/MX', 'SPF/DMARC', 'Disposable', 'Role-based', 'SMTP + Catch-all'].map(c => (
            <span key={c} className="sv-check-chip">{c}</span>
          ))}
        </div>
      </div>

      {loading && (
        <div className="sv-loading">
          <div className="sv-loading-inner">
            <div className="sv-loading-dots">
              <span /><span /><span />
            </div>
            <div>
              <div className="sv-loading-title">Running validation checks…</div>
              <div className="sv-loading-sub">Checking DNS, SPF, DMARC, and SMTP records</div>
            </div>
          </div>
        </div>
      )}

      {result && <ResultCard result={result} />}
    </div>
  );
}
